import { render, staticRenderFns } from "./NumericPagination.vue?vue&type=template&id=315d91b6"
import script from "./NumericPagination.vue?vue&type=script&lang=js"
export * from "./NumericPagination.vue?vue&type=script&lang=js"
import style0 from "./NumericPagination.vue?vue&type=style&index=0&id=315d91b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports